<template>
  <div class="page-content">
    <!-- 顶部 top -->
    <!-- <div class="tap-title">
      <span>产品注册</span>
    </div> -->
    <el-row class="product-menu" type="flex" justify="space-between">
      <el-col :span="8">
        <el-button type="primary" class="first-btn" @click="addProduct">添加产品</el-button>
        <el-button class="refalsh" @click="refresh">刷新</el-button>
      </el-col>
      <el-col class="right" :span="4">
        <el-input placeholder="请输入产品名称查询" v-model.trim="productNameInput" @keyup.13.native="handlerKeyUp" clearable>
          <el-button slot="append" icon="el-icon-search" @click="demand"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <!-- table部分 -->
    <!-- 列表 -->
    <el-row class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="productName" label="产品名称" align="center">
        </el-table-column>
        <el-table-column prop="productKey" label="product_key" align="center">
        </el-table-column>
        <el-table-column prop="vendorId" label="厂商Id" align="center">
        </el-table-column>
        <el-table-column prop="vendorModelId" label="型号Id" align="center">
        </el-table-column>
        <el-table-column prop="connectionType" label="连网方式" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.connectionType === 1 ? 'WI-FI' : scope.row.connectionType === 2 ?
              'Zigbee' : scope.row.connectionType === 3 ? '蓝牙' : scope.row.connectionType === 4 ?
                '蜂窝(2G/3G/4G)' : scope.row.connectionType === 5 ? '以太网' : scope.row.connectionType === 6?
              'LoRaWAN':'其他'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="添加时间" align="center">
        </el-table-column>
        <el-table-column prop="operation" label="操作" align="center" width="300">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" class="check" @click="handleClick(scope.row, 'check')">
              查看
            </el-button>
            <el-button @click="handleClick(scope.row, 'delete')" size="mini" type="danger" style="margin-right:10px"
              slot="reference">
              删除
            </el-button>
            <el-button @click="handleClick(scope.row, 'stop')" v-if="scope.row.isEnable === true" size="mini"
              type="warning" slot="reference">
              禁用
            </el-button>
            <el-button @click="handleClick(scope.row, 'start')" v-if="scope.row.isEnable === false" size="mini"
              type="success" slot="reference">
              启用
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页功能 -->
    <Paging :total="total" @changePage="changePage" />
    <!-- <ProductDialog v-if="dialogFormVisible" :dialogFormVisible="dialogFormVisible" @closeDialog="closeDialog"/> -->

    <addProductDialogSteps @closeSteps="closeSteps" v-if="allStepsVisible" :operate="operate" :addProductDetail="addProductDetail" :visible="allStepsVisible"  @closeDialog="closeDialog"></addProductDialogSteps>


    <!-- <addProductDialogStep1 :productDetail="addProductDetail" :operate="operate" :currentStep="currentStep"
      @nextStep="nextStep" v-show="currentStep === 1" @closeDialog="closeDialog" />

    <addProductDialogStep2 :expandDto="addProductDetail.expandDto" :currentStep="currentStep" :operate="operate"
      @nextStep="nextStep" @prevStep="prevStep" v-show="currentStep === 2" @closeDialog="closeDialog" />

    <addProductDialogStep3 :expandDto="addProductDetail.expandDto" :currentStep="currentStep" v-show="currentStep === 3"
      @prevStep="prevStep" @nextStep="nextStep" @closeDialog="closeDialog" />

    <addProductDialogStep4 :productDetail="addProductDetail" :currentStep="currentStep" v-show="currentStep === 4"
      @prevStep="prevStep" @delImg="delImg" @nextStep="nextStep" @closeDialog="closeDialog" /> -->
  </div>
</template>

<script>
import addProductDialogSteps from '@/components/product_control/addProductDialogSteps'
import addProductDialogStep1 from '@/components/product_control/addProductDialogStep1'
import addProductDialogStep2 from '@/components/product_control/addProductDialogStep2'
import addProductDialogStep3 from '@/components/product_control/addProductDialogStep3'
import addProductDialogStep4 from '@/components/product_control/addProductDialogStep4'
import Paging from '@/components/paging'
import { productList, deleteByProductId, startByProductId, stopByProductId } from '@/api/productRegistration'

import { deleteProductFile } from '@/api/fileServer'
import eventBus from '@/assets/js/eventBus'
export default {
  data() {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listLoading: false, // 根据loading来进行显示/隐藏
      listQuery: {
        page: 1,
        limit: 10
      },
      productNameInput: '',
      optionsValue: '', // option选择的值
      tableData: [],
      currentPage1: 2, // 页面所在位置
      // dialogFormVisible: false, // 蒙版开关
      params: {}, // 接口传参
      currentStep: -1,
      operate: '',
      addProductDetail: {
        expandDto: {}// 这里存放扩展的数据
      }, // 用于保存每个步骤的产品数据
      delImgArr: [], // 保存用于删除的图片的token
      allStepsVisible: false,
      
    }
  },
  created() {
    eventBus.$on('addDelImg', this.addDelImg)
    this.getProductList()
  },
  watch: {
    // productNameInput: {
    //   handler (val) {
    //     if (val === '') {
    //       this.demand()
    //     }
    //   }
    // }
  },
  components: {
    Paging,
    addProductDialogSteps,
    addProductDialogStep1,
    addProductDialogStep2,
    addProductDialogStep3,
    addProductDialogStep4
  },
  methods: {
    
    closeSteps() {
      this.allStepsVisible = false;
      this.getProductList()
    },
    addDelImg(arr) {
      this.delImgArr = this.delImgArr.concat(arr)
      console.log('删除的delImgArr：', this.delImgArr)
    },
    delImg() {
      // 去重
      let imgArray = [...new Set(this.delImgArr)]
      imgArray = imgArray.filter(item => {
        return item !== ''
      })
      if (imgArray.length === 0) {
        return
      }
      deleteProductFile(imgArray).then(res => {
      }).catch(e => {
      })
      // 清空
      this.delImgArr.splice(0)
    },
    prevStep(currentStep) {
      console.log('prevStep addProductDetail', this.addProductDetail)
      this.currentStep = currentStep
    },
    nextStep(currentStep) {
      console.log('addProductDetail', this.addProductDetail)
      this.currentStep = currentStep
    },
    getProductList() {
      this.params.pageNumber = this.listQuery.page
      this.params.pageSize = this.listQuery.limit
      const params = {
        params: this.params
      }
      productList(params).then(res => {
        if (res.data.code === 200) {
          if (res.data.data.total.total < 5) {
            this.listLoading = true
          } else {
            this.listLoading = false
          }
          this.total = res.data.data.total
          this.tableData = res.data.data.list
          // console.log('--------------------------', this.tableData)
        }
      })
    },
    // enter 键事件
    handlerKeyUp(e) {
      if (e.keyCode === 13) {
        this.demand()
      }
    },
    // 根据固件名查询列表
    demand() {
      this.listQuery.page = 1
      this.params.productName = this.productNameInput
      this.getProductList()
    },
    // 刷新按钮事件
    refresh() {
      this.listQuery.page = 1
      this.getProductList()
    },
    // 分页管理
    changePage(val) {
      this.listQuery = val
      this.getProductList()
    },
    // 添加产品事件
    addProductEvent() {
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid)
        if (valid) {
          const form = JSON.parse(JSON.stringify(this.form))
          fetch({
            url: '/producttype/add', //  1
            method: 'post',
            data: form
          }).then(res => {
            this.$message({
              type: 'success',
              message: '保存成功!'
            })
            // this.dialogFormVisible = false   到时候这个地方关闭
          }).catch(res => {
            this.$message({
              type: 'error',
              message: res.msg
            })
          })
        } else {
          this.$message({
            type: 'error',
            message: '添加品类失败!'
          })
          return false
        }
      })
    },
    // 添加产品按钮
    addProduct() {
      this.allStepsVisible = true;
      // this.addProductDetail = {
      //   expandDto: {}// 这里存放扩展的数据
      // }// 重置产品详情
      // eventBus.$emit('resetFields')// 重置所有步骤的form表单
      // this.currentStep = 1
      // this.dialogFormVisible = true
    },
    closeDialog(status) {
      this.allStepsVisible = false;
      if (status) {
        // this.dialogFormVisible = false
        this.currentStep = -1
        this.listQuery.page = 1
        this.getProductList()
      } else {
        // this.dialogFormVisible = false
        this.currentStep = -1
      }
    },
    handleClick(sRow, status) {
      const params = {
        params: {
          productKey: sRow.productKey
        }
      }
      // console.log('------------------', sRow)
      // const infos = JSON.stringify(sRow)
      const infos = JSON.stringify({
        productKey: sRow.productKey,
        productName: sRow.productName
      })
      switch (status) {
        // 查看详情
        case 'check':
          localStorage.setItem('infos', infos)
          this.$router.push(
            { path: './productDetail', query: { sRow: infos } }
          )
          break
        case 'delete':
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'error'
          }).then(() => {
            deleteByProductId(params).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.getProductList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
          break
        case 'stop':
          stopByProductId(params)
            .then(Response => {
              this.$message({
                type: 'success',
                message: '禁用成功'
              })
              this.getProductList()
            })
          break
        case 'start':
          startByProductId(params)
            .then(Response => {
              this.$message({
                type: 'success',
                message: '启用成功'
              })
              this.getProductList()
            })
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-content {
  .first-btn {
    width: 98px;
    height: 40px;
  }

  .reflash {
    width: 70px;
    height: 40px;
  }

  .el-button {
    border-radius: 2px
  }

  /deep/ .el-form-item__label {
    text-align: center;
  }

  .tap-title {
    margin-bottom: 30px;
    padding-left: 10px;
    display: flex;
    border-left: 5px solid skyblue;
    font-size: 16px;
  }

  .product-menu {
    margin-bottom: 20px;
  }

  .imgbox {
    /deep/ .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    /deep/ .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }

    /deep/ .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }

    /deep/ .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }

  .noAllow {
    color: #c1c1c1;
    cursor: not-allowed
  }

  .check {
    margin-right: 10px;
  }
}
</style>
